/**
 * Type definitions for persisted state structures
 */

export interface NavState {
    isNavOpened: boolean;
}

export interface HelpPanelState {
    toolsOpen: boolean;
    helpPanelTopic?: string | null;
}

/**
 * Type guards/validators for persisted state
 */

export function isNavState(value: any): value is NavState {
    return (
        typeof value === 'object' &&
        value !== null &&
        typeof value.isNavOpened === 'boolean'
    );
}

export function isHelpPanelState(value: any): value is HelpPanelState {
    return (
        typeof value === 'object' &&
        value !== null &&
        typeof value.toolsOpen === 'boolean' &&
        (value.helpPanelTopic === null ||
            value.helpPanelTopic === undefined ||
            typeof value.helpPanelTopic === 'string')
    );
}
